import React from "react";

import { faChevronDown, faChevronUp } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import stylesObjective from "~/okrs/Objective.module.css";

import styles from "./CollapsibleDescription.module.css";

export default function CollapsibleDescription({ description }: { description: string }) {
	const descriptionRef = React.useRef<HTMLDivElement | null>(null);
	const [hasShowMore, setHasShowMore] = React.useState(false);
	const [expanded, setExpanded] = React.useState(false);

	const expand = React.useCallback((event: React.MouseEvent<HTMLDivElement>) => {
		setExpanded(true);
		event.preventDefault();
	}, []);

	const collapse = React.useCallback((event: React.MouseEvent<HTMLDivElement>) => {
		setExpanded(false);
		event.preventDefault();
	}, []);

	React.useEffect(() => {
		if (!descriptionRef.current) {
			return;
		}

		const isOverflown = descriptionRef.current?.scrollHeight > descriptionRef.current?.clientHeight;
		setHasShowMore(isOverflown);
	}, [description]);

	return (
		<div className={cx(styles.wrapper, stylesObjective.descriptionData)}>
			<div className={cx(styles.description, { [styles.expanded]: expanded })} ref={descriptionRef}>
				<pre>{description}</pre>
			</div>

			{hasShowMore && (
				<>
					{expanded ? (
						<div className={styles.collapser} onClick={collapse}>
							Show less
							<FontAwesomeIcon icon={faChevronUp} />
						</div>
					) : (
						<div className={styles.collapser} onClick={expand}>
							Show more
							<FontAwesomeIcon icon={faChevronDown} />
						</div>
					)}
				</>
			)}
		</div>
	);
}
